import React, { Component } from 'react';
import { Container } from 'reactstrap';

class Landing extends Component {
  constructor (props) {
    super(props);
    this.state = {};
  }
  render () {
    return <div>
      <Container className='pt-5'>
        <br />
        <div className='page-container'>
          <h3>Give yourself, and your family, financial peace of mind</h3>
          <br />
          <p>
            We now offer you financial peace of mind when it matters most.
            Oats Funeral Cover ensures that you and your loved ones are covered
            from the financial burden associated with a death in the family.
          </p>
          <br />
          <a className='btn btn-primary px-5' href='/funeral/apply'>Get a quote</a>
          <br />
          <br />
          <br />
          <h4>What are the benefits of Oats Funeral Cover?</h4>
          <br />
          <p>
            With Oats Funeral Cover you can cover yourself as well as your
            immediate and extended family. You, or your dependants, will be
            paid a lump sum payment within a matter of hours from making a claim.
          </p>
          <ul>
            <li>Get covered immediately, no medical tests required.</li>
            <li>Insure you and your family member for anything between R10,000 - R100,000.</li>
            <li>Access to funds within 48 hours of claiming.</li>
            <li>No waiting period for accidental death.</li>
          </ul>
        </div>
      </Container>
      <footer>
        <hr />
        <img id='guardrisk-logo' src='/funeral/guardrisk-mmi-logo.png' />
        <p>
          <b>© 2018 Oats Risk Services Limited. All rights reserved.</b>
          <br />
          Oats risk services (Pty) Limited is an authorised financial services provider, FSP no. 49169 | Oats Funeral Cover is underwritten by Guardrisk Life Limited (Reg no. 1999/013922/06), a registered Financial Services Provider, FSP no. 76.
        </p>
      </footer>
    </div>;
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/landing.js